module.exports = __webpack_public_path__ + "static/vaccination960_1210-0db3386b156251f2dcf39b8b0e3e02e1.png";